/**
 * Validate a `?next=` redirect target.
 *
 * A redirect destination that arrives in the URL is attacker-controlled:
 * anyone can send a link to `/login?next=https://evil.example/harvest`,
 * and a page that forwards there after sign-in has handed over whatever
 * the user does next while believing they are still on NexBasira.
 *
 * So: same-origin paths only, and nothing that could be read as another
 * host. `//evil.example` is the one that catches people out — the
 * browser treats it as protocol-relative and leaves the site.
 */
export function safeNextPath(raw: string | null | undefined): string | null {
  if (!raw) return null;
  // Decoded once, because `%2F%2Fevil.example` is `//evil.example`.
  let value = raw;
  try {
    value = decodeURIComponent(raw);
  } catch {
    return null;
  }
  value = value.trim();
  if (!value.startsWith("/")) return null;
  if (value.startsWith("//")) return null;
  // A backslash is normalised to a slash by some browsers, so `/\evil`
  // can escape the origin the same way `//evil` does.
  if (value.startsWith("/\\")) return null;
  return value;
}
